import React from 'react';
import st from "../common.module.scss";
import FlexLine from "@elements/flexLine/FlexLine";
import { TextType } from "@baseTypes/baseType";
import ChartHeader from "@elements/chart/ChartHeader";
import Tx from "@baseTypes/naming";
import { EmptyTextBlock } from "@pages/dashboard/crops/empty";

const Empty = () => {
	return (
		<div className={st.empty_block}>
			<FlexLine textType={TextType.Header} className={st.header}>
				<ChartHeader>{Tx.StateCrops}</ChartHeader>
				<div className={st.total_label}>0 Га
				</div>
			</FlexLine>
			<svg xmlns="http://www.w3.org/2000/svg" width="768" height="288" viewBox="0 0 768 288" fill="none">
				<rect x="16" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="80" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="144" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="208" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="272" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="336" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="400" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="464" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="528" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="592" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="656" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<rect x="720" y="5.875" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<g clip-path="url(#clip0_11156_6713)">
					<mask id="path-13-inside-1_11156_6713" fill="white">
						<path d="M0 24H768V287.657H0V24Z"/>
					</mask>
					<path d="M0 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M64 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M128 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M192 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M256 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M320 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M384 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M448 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M512 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M576 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M640 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<path d="M704 24V287.657" stroke="#CDCED1" strokeWidth="0.5"/>
					<rect x="171" y="35.6328" width="213" height="24" rx="8" fill="#EAEAEB"/>
					<rect x="365.702" y="65.3428" width="137" height="24" rx="8" fill="#EAEAEB"/>
					<rect x="104.173" y="124.764" width="108.67" height="24" rx="8" fill="#EAEAEB"/>
					<rect x="349.056" y="154.882" width="266.955" height="24" rx="8" fill="#EAEAEB"/>
					<rect x="415" y="95.0537" width="147" height="24" rx="8" fill="#EAEAEB"/>
					<rect x="527.599" y="184.241" width="200.57" height="24" rx="8" fill="#EAEAEB"/>
					<rect x="435.618" y="214.36" width="204.382" height="24" rx="8" fill="#EAEAEB"/>
				</g>
				<path
					d="M0 24V23H-1V24H0ZM768 24H769V23H768V24ZM0 25H768V23H0V25ZM767 24V287.657H769V24H767ZM1 287.657V24H-1V287.657H1Z"
					fill="#CDCED1" mask="url(#path-13-inside-1_11156_6713)"/>
				<defs>
					<clipPath id="clip0_11156_6713">
						<path d="M0 24H768V287.657H0V24Z" fill="white"/>
					</clipPath>
				</defs>
			</svg>

			<div className={st['empty_block__blur']}>
				<svg width="816" height="400" viewBox="0 0 816 400" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="816" height="400" fill="url(#paint0_linear_11156_6761)"/>
					<defs>
						<linearGradient id="paint0_linear_11156_6761" x1="408" y1="42.6063" x2="408" y2="311.874"
										gradientUnits="userSpaceOnUse">
							<stop offset="0.460045" stopColor="white" stopOpacity="0"/>
							<stop offset="0.831741" stopColor="white" stopOpacity="0.958507"/>
							<stop offset="1" stopColor="white"/>
						</linearGradient>
					</defs>
				</svg>
			</div>

			<EmptyTextBlock subtitle={'Для просмотра этого графика выберите другую культуру'} />
		</div>
	)
}

export default Empty;